// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uHwnb","footer":"styles_footer__ourv1"};